import { createCollectionReducer } from 'ext/lib/collections';
import { TYPE } from './actions';

export default createCollectionReducer(TYPE);

export const selectThemes = state => state[TYPE];

export const selectDefaultTheme = state =>
  Object.values(selectThemes(state)).find(theme => theme.isDefault);
